import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/crateBooking'

const crateBooking = axios.create({
  baseURL
})

interceptorsSetup(crateBooking)

export default class CrateBookings {
  static async getTable (bookingQuery) {
    const result = await crateBooking.get('/' + bookingQuery.siteId, {
      params:
      {
        start: bookingQuery.start,
        end: bookingQuery.end
      }
    })
    return result.data
  }
  static async createBooking (booking) {
    const result = await crateBooking.post('/', booking)
    return result.data
  }
  static async updateBooking (booking) {
    const result = await crateBooking.post('/update', booking)
    return result.data
  }
  static async archiveBooking (booking) {
    const result = await crateBooking.put('/archive/' + booking)
    return result.data
  }
}
